<template>
  <section class="invoice-receive-payment-wrapper">
    <b-card no-body>
      <div class="m-2">
        <b-row>
          <b-col md="12">
            <div class="d-flex align-items-center justify-content-between">
              <h2>
                {{ $t("cashiers.receive-payment-title") }} - {{ invoiceId }}
              </h2>
              <b-button
                variant="outline-secondary"
                size="sm"
                @click="$router.back()"
              >
                <feather-icon icon="ArrowLeftIcon" class="mr-1" size="14" />
                {{ $t("cashiers.back-to-list") }}
              </b-button>
            </div>
          </b-col>
          <b-col cols="12" md="12"><br /></b-col>

          <b-col md="4" cols="12">
            <b-form-group :label="$t('common.amount')" label-for="amount">
              <b-form-input
                id="amount"
                v-model.number="form.amount"
                type="number"
                min="0"
                step="0.01"
              />
            </b-form-group>
          </b-col>
          <b-col md="4" cols="12">
            <b-form-group :label="$t('common.date')" label-for="paid-at">
              <datepicker
                id="paid-at"
                v-model="form.paid_at"
                :calendar-button="true"
                :clear-button="true"
                :bootstrap-styling="true"
                class="datebtn2"
                placeholder="YYYY-MM-DD"
              />
            </b-form-group>
          </b-col>
          <b-col md="4" cols="12">
            <b-form-group :label="$t('common.description')" label-for="note">
              <b-form-input id="note" v-model="form.note" />
            </b-form-group>
          </b-col>
        </b-row>

        <b-row>
          <b-col>
            <b-button
              :disabled="submitting"
              variant="success"
              @click="submitPayment()"
            >
              {{ $t("cashiers.receive-payment") }}
            </b-button>
          </b-col>
        </b-row>
      </div>
    </b-card>
  </section>
</template>

<script>
import {
  BRow,
  BCol,
  BCard,
  BFormGroup,
  BFormInput,
  BButton,
} from "bootstrap-vue";
import Datepicker from "vuejs-datepicker";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

export default {
  name: "ReceivePayment",
  components: {
    BRow,
    BCol,
    BCard,
    BFormGroup,
    BFormInput,
    BButton,
    Datepicker,
  },
  data() {
    return {
      invoiceId: null,
      submitting: false,
      form: {
        amount: null,
        paid_at: null,
        note: "",
      },
    };
  },
  mounted() {
    this.invoiceId = this.$route.params.invoice;
  },
  methods: {
    async submitPayment() {
      if (!this.invoiceId) return;
      this.submitting = true;
      try {
        const payload = { ...this.form };
        if (payload.paid_at && typeof payload.paid_at !== "string") {
          const d = new Date(payload.paid_at);
          payload.paid_at = d.toISOString().split("T")[0];
        }
        await this.create({
          path: `invoices/${this.invoiceId}/receive-payment`,
          form: payload,
        });
        this.$toast({
          component: ToastificationContent,
          props: {
            title: this.$t("common.success"),
            icon: "CheckIcon",
            variant: "success",
            text: this.$t("cashiers.payment-received-success"),
          },
        });
        this.$router.back();
      } catch (error) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: this.$t("common.error"),
            icon: "AlertCircleIcon",
            variant: "danger",
            text:
              error.response?.data?.message ||
              this.$t("cashiers.payment-received-failed"),
          },
        });
      } finally {
        this.submitting = false;
      }
    },
  },
};
</script>

<style scoped></style>
